<template>
    <transition-group name="messages" tag="div" class="message-flow-container">
        <div v-for="message in renderMessages" :key="message.id" class="message">
            <div class="message-flow-wrapper">
                <img :src="message.artist_pic" class="artist-img" />
                <div class="message-flow">
                    <div class="message-header">{{ message.artist_name }} &nbsp; 11:05 Pm</div>
                    <div class="message-hello" v-if="message.message_header.length">
                        <span class="text-tup">{{ message.message_header }}</span>
                    </div>
                    <transition name="message" mode="out-in">
                        <div v-if="!message.showAllText" key="short-text" class="text-tup">
                            ...
                        </div>
                        <div v-else key="long-text" class="main-text">
                            <span class="text-tup">{{ message.message_text }}</span>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </transition-group>
</template>

<script>
    export default {
        name: 'MessageFlow',
        props: {
            animate: {
                required: true,
                type: Boolean
            }
        },
        data() {
            return {
                messages: [
                    {
                        id: 1,
                        show: false,
                        artist_pic: '/images/icons/message-flow/maxine.svg',
                        artist_name: 'Maxine',
                        message_header: 'Hey All!',
                        message_text:
                            'Are you all cool with sharing merch table? We typically set up a large folding table in the corner since space is a little tight...',
                        showAllText: false
                    },
                    {
                        id: 2,
                        show: false,
                        artist_pic: '/images/icons/message-flow/pixel.svg',
                        artist_name: 'Pixel Rainbow',
                        message_header: '',
                        message_text:
                            "For sure! We've mostly got t-shirts and a couple LP's , shouldn't be a problem.",
                        showAllText: true
                    },
                    {
                        id: 3,
                        show: false,
                        artist_pic: '/images/icons/message-flow/dreambot.svg',
                        artist_name: 'Dreambot Castaway',
                        message_header: '',
                        message_text:
                            ' Yeah that works for us too! Any chance we can get a couple drink vouchers for our merch guy? 😀',
                        showAllText: true
                    },
                    {
                        id: 4,
                        show: false,
                        artist_pic: '/images/icons/message-flow/maxine.svg',
                        artist_name: ' Maxine',
                        message_header: '',
                        message_text:
                            "Totally! We'll give your crew a couple vouchers each 😎",
                        showAllText: true
                    }
                ],
                renderMessages: [],
                animationInterval: null,
                animationTimer: 2000
            }
        },
        methods: {
            startAnimations() {
                if (!this.renderMessages.length) {
                    this.$set(this.renderMessages, 0, this.messages[0])
                }

                this.animationInterval = setInterval(() => {
                    let indx = this.renderMessages.length

                    if (indx <= this.messages.length - 1) {
                        this.$set(this.renderMessages, indx, this.messages[indx])
                    }
                }, this.animationTimer)
            }
        },
        watch: {
            animate: function (animate) {
                if (animate) {
                    this.startAnimations()
                }
            },
            renderMessages: function (renderMessages) {
                if (renderMessages.length === 2) {
                    renderMessages[0].showAllText = true
                }
            }
        },
        beforeDestroy() {
            clearInterval(this.animationInterval)
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .messages-enter {
        opacity: 0;
        transform: translateY(50px);
    }
    .messages-enter-active {
        transition: all 1.5s ease-in-out;
    }
    .messages-enter-to {
        opacity: 1;
    }
    .message-enter {
        max-height: 0px;
    }
    .message-enter-active {
        transition: max-height 0.25s ease-in-out;
    }
    .message-enter-to {
        max-height: 80px;
    }
    .message-flow-container {
        display: flex;
        flex-direction: column;
        z-index: 3;
        gap: 10px;
        flex-basis: 45%;
        transform: translateY(-15%);
    }
    .message-flow-wrapper {
        display: flex;
        flex-direction: row;
        gap: 5px;
        align-items: flex-start;
    }
    .artist-img {
        width: 42px;
        height: 42px;
        object-fit: cover;
        border-radius: 50%;
    }
    .img {
        max-width: 40px;
        border-radius: 50%;
    }
    .message {
        height: 100%;
        width: 100%;
        min-width: 370px;
    }
    .message-flow {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: flex-start;
        flex-basis: 80%;
        justify-content: flex-start;
        padding: 15px;
        border-radius: 15px;
        background: #646464;
        padding-right: 50px;
        margin-left: 10px;
        width: auto;
        overflow: hidden;
    }
    .message-header {
        color: var(--gray-4, #8b8b8b);
        font-family: Instrument Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        padding-bottom: 15px;
    }
    .message-hello {
        padding-bottom: 20px;
    }
    .text-tup {
        color: var(--gray-6, #dedede);
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
</style>
